// extracted by mini-css-extract-plugin
export default {"heading":"Yi-z","list":"Zi-z"};